import type { ReactElement } from 'react'
import { ErrorBoundary } from './components/ErrorBoundary.js'
import { DemoProvider } from './state/store.js'
import { useStep } from './state/useStep.js'
import { SCREENS } from './screens/registry.js'
import { usePreloadProofPhotos } from './lib/preload.js'

const Router = (): ReactElement | null => {
  const { step } = useStep()
  const Screen = SCREENS[step]
  return <Screen />
}

export const App = (): ReactElement => {
  usePreloadProofPhotos()
  return (
    <ErrorBoundary>
      <DemoProvider>
        <Router />
      </DemoProvider>
    </ErrorBoundary>
  )
}
